/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import DeleteModal from '../../components/deleteComponent/deleteModal'
import DeleteAxios from '../../components/axiosComponent/delete'

function JobcardActionButton(props) {

  const [branchId, setbranchId] = useState('')
  const [openBox, setopenBox] = useState(false)
  const [success, setsuccess] = useState(false)
  const [isAnAdmin, setIsAnAdmin] = useState((localStorage.getItem('role').toLowerCase() == 'elixir' || localStorage.getItem('role').toLowerCase() == 'administrator') ? 1 : -1)

  let handleClose = () => {
    setopenBox(false)
  }

  let handleDelete = () => {
    setsuccess(true)
    let id = branchId
    DeleteAxios({
      url: 'fleet/jobcard/delete',
      deleteItems: {
        jobCardId: id,
        approvalStatus: props.data.statusId
      },
      deleted: (data) => {
        if (data && data.status === 1) {
          setTimeout(() => {
            setsuccess(false)
            window.location.reload()
          }, 500);
        }
      }
    })
  }

  let handleOpenEdit = (e) => {
    let mainData = props.data
    let history = props.agGridReact.props.BaseUrl.history
    history.push({ pathname: '/edit-jobcard', state: { id: mainData.id, vehicleId: mainData.vehicleId, jobCardType: mainData.name, data: mainData } })
  }

  let handleOpenView = (e) => {
    let mainData = props.data
    let history = props.agGridReact.props.BaseUrl.history
    history.push({ pathname: '/jobcard-info', state: { id: mainData.id, vehicleId: mainData.vehicleId, jobCardType: mainData.name } })
  }

  let handleOpenDelete = (e) => {
    let mainData = props.data
    setbranchId(mainData.id)
    setopenBox(true)
  }

  let mainData = props.data

  return (
    <>
      <Button disabled={((mainData && mainData.statusId > 2) || (isAnAdmin == 1 && mainData && mainData.adminEditFlag == 1)) ? true : false} onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
      <Button onClick={handleOpenView} basic size="mini" type="button" icon> <Icon name="eye" color="green" /></Button>
      <Button disabled={((mainData && mainData.statusId > 2) || (isAnAdmin == 1 && mainData && mainData.adminDeleteFlag == 1)) ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
      <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} />
    </>
  )

}

export default JobcardActionButton
